/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     设备增值 API
  | @Version:   2019-12-17  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST;
export function homeStatApi() {
  return request({
    url: `${ jsApiHost }/expense/ei/home/stat`,
    method: 'get'
  })
}

export function homeHistoryApi() {
  return request({
    url: '?c=ei&a=home&do=history',
    method: 'get'
  })
}

export function homeCurrentApi() {
  return request({
    url: '?c=ei&a=home&do=current',
    method: 'get'
  })
}

export function homeFutureApi() {
  return request({
    url: '?c=ei&a=home&do=future',
    method: 'get'
  })
}

export function addvalueListApi(query) {
  return request({
    url: jsApiHost + '/ei/rms/list',
    method: 'get',
    params: query
  })
}

export function schemeListApi(query) {
  return request({
    url: `${ jsApiHost }/ei/scheme/list`,
    method: 'get',
    params: query
  })
}

export function allSchemeApi(query) {
  return request({
    url: `${ jsApiHost }/ei/scheme/getall`,
    method: 'get',
    params: query
  })
}

export function getSchemeApi(query) {
  return request({
    url: '?c=ei&a=scheme&do=get',
    method: 'get',
    params: query
  })
}


export function delSchemeApi(data) {
  return request({
    url: `${ jsApiHost }/ei/scheme/delete`,
    method: 'post',
    data
  })
}

export function postConfigApi(data) {
  return request({
    url: '?c=ei&a=rms&do=post',
    method: 'post',
    data: data
  })
}

export function incomeListApi(query) {
  return request({
    url: '?c=ei&a=detail&do=list',
    method: 'get',
    params: query
  })
}

export function godBlanceApi(params) {
  return request({
    url: `${jsApiHost}/expense/balance`,
    method: 'get',
    params
  })
}

export function agreementApi() {
  return request({
    url: '?c=ei&a=agreement&do=get',
    method: 'get'
  })
}

export function eiModuleApplyApi(data) {
  return request({
    url: '?c=module&a=open&do=apply',
    method: 'post',
    data: data
  })
}

export function eiAgreementTplApi() {
  return request({
    url: '?c=ei&a=agreement&do=gettpl',
    method: 'get'
  })
}

export function eiChargeDefault(data) {
  return request({
    url: '?c=ei&a=default&do=post',
    method: 'post',
    data: data
  })
}

export function eiSetManyChargeApi(data) {
  return request({
    url: '?c=ei&a=rms&do=batch',
    method: 'post',
    data
  })
}

export function eiIndexConditionApi() {
  return request({
    url: '?c=ei&a=home&do=overview',
    method: 'get'
  })
}

export function incomeOverviewApi(query) {
  return request({
    url:  `${ jsApiHost }/expense/ei/stat`,
    method: 'get',
    params: query
  })
}

export function postSchemeApi(data) {
  return request({
    url: `${ jsApiHost }/ei/scheme/post`,
    method: 'post',
    data
  })
}

export function getSchemeDetailApi(query) {
  return request({
    url: `${ jsApiHost }/ei/scheme/get`,
    method: 'get',
    params: query
  })
}

export function proPresentApi(data) {
  return request({
    url: `${ jsApiHost }/ei/pro/present`,
    method: 'post',
    data
  })
}

export function schemeStatApi(query) {
  return request({
    url: `${ jsApiHost }/ei/scheme/stat`,
    method: 'get',
    params: query
  })
}

export function aiotversionGetApi(query) {
  return request({
    url: `${ jsApiHost }/god/aiotversion/get`,
    method: 'get',
    params: query
  })
}

export function getQrcodeApi(data) {
  return request({
    url:  jsApiHost + '/utility/qrcode/wxapp/unlimited',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

export function schemeRecommendApi(query) {
  return request({
    url: `${ jsApiHost }/ei/scheme/recommend/list`,
    method: 'get',
    params: query
  })
}